import { render, staticRenderFns } from "./Gasto.vue?vue&type=template&id=0fd5ed10&scoped=true&"
import script from "./Gasto.vue?vue&type=script&lang=js&"
export * from "./Gasto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5ed10",
  null
  
)

export default component.exports